export default "__VITE_ASSET__vpyUn3Qu__"